document.addEventListener('DOMContentLoaded', () => {
  const tabContainer = document.querySelector('.c-news-tabs');
  if (!tabContainer) return;

  const tabs = tabContainer.querySelectorAll('.c-news-tabs__item');
  const newsItems = document.querySelectorAll('.c-card-news-item');
  const newsListContainer = document.querySelector('.c-card-news-list');

  // 初期表示時のフィルタリングを追加
  const filterItems = (status) => {
    let visibleItemCount = 0;
    newsItems.forEach(item => {
      const itemStatus = item.dataset.status;
      if (status === 'all' || status === itemStatus) {
        item.style.display = '';
        visibleItemCount++;
      } else {
        item.style.display = 'none';
      }
    });

    if (newsListContainer) {
      if (visibleItemCount === 0) {
        newsListContainer.style.display = 'none';
      } else {
        newsListContainer.style.display = '';
      }
    }
  };

  // 初期表示時に「すべて」を表示
  filterItems('all');

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      // タブのアクティブ状態を切り替え
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      // 記事の表示/非表示を切り替え
      const status = tab.dataset.status;
      filterItems(status);
    });
  });
}); 